import React from "react";
import { createRoot } from "react-dom/client";
import App from "Pages/App";
import * as serviceWorker from "./serviceWorker";
import TagManager from "react-gtm-module";
import {
  APP_ROOT,
  FEO_APPKEY,
  FEO_ENV,
  GTM_MEASUREMENTID,
} from "Utils/EnvVars";
import { createBrowserHistory } from "history";
import { Route } from "react-router-dom";
import {
  createReactRouterV5Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import "@pav/pav-products-design-system/assets/style.css";
import {
  ThemeProvider,
  CssBaseline,
  theme,
  InitColorSchemeScript,
} from "@pav/pav-products-design-system";
import { BrowserRouter as Router } from "react-router-dom";
import { GPURLPATH, PAVILIONURLPATH } from "Utils/Constants";
import { LastEnrollmentStepProvider } from "context/LastEnrollmentStepProvider";

const container = document.getElementById("root");
const root = createRoot(container);
const tagManagerArgs = {
  gtmId: GTM_MEASUREMENTID,
};
const history = createBrowserHistory();

TagManager.initialize(tagManagerArgs);

initializeFaro({
  url: `https://faro-collector-prod-us-central-0.grafana.net/collect/${FEO_APPKEY}`,
  app: {
    name: "vip-preferred-sdk",
    version: "1.0.0",
    environment: `${FEO_ENV}`,
  },
  ignoreUrls: [/google-analytics\.com/],
  sessionTracking: {
    enabled: true,
  },
  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation({
      instrumentationOptions: {
        propagateTraceHeaderCorsUrls: [
          new RegExp("https://*.api-gaming.paviliononline.io/sdk"),
        ],
      },
    }),
    new ReactIntegration({
      router: createReactRouterV5Options({
        history,
        Route,
      }),
    }),
  ],
  trackWebVitalsAttribution: true,
});

root.render(
  <ThemeProvider theme={theme} disableTransitionOnChange>
    <CssBaseline enableColorScheme />
    <InitColorSchemeScript attribute="class" />
    <LastEnrollmentStepProvider>
      <Router
        basename={
          window.location.pathname.replace(/\/$/, "") === APP_ROOT
            ? APP_ROOT.replace(/\/$/, "")
            : window.location.pathname.replace(/\/$/, "") === GPURLPATH
              ? GPURLPATH
              : PAVILIONURLPATH
        }
      >
        <App />
      </Router>
    </LastEnrollmentStepProvider>
  </ThemeProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
